import React from "react";
import "./Footer.css";

const Footer = ({ company }) => {
    if (!company) {
      return 
    }
  
    return (
      <footer className="footer">
        <div className="footer-content">
          <span>{company.name || "Geen bedrijfsnaam"}</span>|
          <span>E-mail: {company.email || "Geen e-mail"}</span>
          <span>Telefoon: {company.phone || "Geen telefoonnummer"}</span>
        </div>
      </footer>
    );
  };

export default Footer;
